module.exports = __webpack_public_path__ + "img/lea-28.d9696b19.png";